export const CUSTOMER_FACING_EMAIL_TEMPLATES = Object.freeze([
    {
        templateReferenceId: 3,
        key: 'order_confirmation',
        name: 'Order confirmation',
        description: 'Sent when a fan purchases tickets to an event.',
        defaultHeadline: 'You got tickets!',
        defaultBodyText: 'Your order is confirmed. Your tickets are attached to this email and available in your account.',
    },
    {
        templateReferenceId: 4,
        key: 'resale_order_confirmation',
        name: 'Resale order confirmation',
        description: 'Sent when a fan purchases resale tickets.',
        defaultHeadline: 'You got tickets!',
        defaultBodyText: 'Your resale order is confirmed. Your tickets are available in your account.',
    },
    {
        templateReferenceId: 5,
        key: 'transfer_pending',
        name: 'Transfer pending',
        description: 'Sent when a ticket transfer is waiting to be accepted.',
        defaultHeadline: 'Your transfer is pending!',
        defaultBodyText: 'Someone has initiated a ticket transfer to you. Sign in to accept or decline the transfer.',
    },
    {
        templateReferenceId: 6,
        key: 'transfer_accepted',
        name: 'Transfer accepted',
        description: 'Sent when a ticket transfer has been completed.',
        defaultHeadline: 'Your transfer has been completed!',
        defaultBodyText: "The ticket transfer is complete. The tickets are now in the recipient's account.",
    },
    {
        templateReferenceId: 7,
        key: 'transfer_cancelled',
        name: 'Transfer cancelled',
        description: 'Sent when a ticket transfer is cancelled.',
        defaultHeadline: 'Your transfer has been cancelled',
        defaultBodyText: 'The ticket transfer was cancelled and the tickets remain with the sender.',
    },
    {
        templateReferenceId: 82,
        key: 'transfer_initiated',
        name: 'Transfer initiated',
        description: 'Sent to invite someone to accept transferred tickets.',
        defaultHeadline: 'You have tickets waiting for you!',
        defaultBodyText: 'Tickets have been sent to you. Sign in to claim them and add them to your account.',
    },
    {
        templateReferenceId: 16,
        key: 'refund',
        name: 'Refund',
        description: 'Sent when a fan receives a refund.',
        defaultHeadline: 'You received a refund!',
        defaultBodyText: 'Your refund has been processed. Details about the refunded order are below.',
    },
    {
        templateReferenceId: 133,
        key: 'package_purchase',
        name: 'Package purchase',
        description: 'Sent when a fan purchases a season package.',
        defaultHeadline: 'You just bought a package!',
        defaultBodyText: 'Your package purchase is confirmed. Review your package details below.',
    },
    {
        templateReferenceId: 134,
        key: 'package_assignment',
        name: 'Package assignment',
        description: 'Sent when a season package is assigned, renewed, or delivered to a fan.',
        defaultHeadline: 'Your season tickets are confirmed',
        defaultBodyText: 'Your season tickets are secured and your balance is paid in full. This email is your receipt.',
    },
    {
        templateReferenceId: 145,
        key: 'ticket_assignment',
        name: 'Ticket assignment',
        description: 'Sent when tickets are assigned or sent to a fan.',
        defaultHeadline: 'Tickets have been sent to you!',
        defaultBodyText: 'Tickets have been sent to your account. They are attached to this email and ready to use.',
    },
    {
        templateReferenceId: 146,
        key: 'access_pass_confirmation',
        name: 'Access pass confirmation',
        description: 'Sent when an organizer access pass is purchased online or assigned to a fan.',
        defaultHeadline: 'Your access pass is ready!',
        defaultBodyText: 'Your access pass is confirmed and available in your account when you sign in.',
    },
    {
        templateReferenceId: 147,
        key: 'invoice',
        name: 'Invoice',
        description: 'Sent when an invoice is emailed to a fan, including reserved season-ticket invoices.',
        defaultHeadline: 'Your invoice is ready',
        defaultBodyText: 'Please review your invoice below and pay by the due date. Click Pay Now to complete payment securely.',
    },
]);
export const CUSTOMER_FACING_EMAIL_TEMPLATE_IDS = CUSTOMER_FACING_EMAIL_TEMPLATES.map((template) => template.templateReferenceId);
export function getCustomerFacingEmailTemplate(templateReferenceId) {
    return CUSTOMER_FACING_EMAIL_TEMPLATES.find((template) => template.templateReferenceId === templateReferenceId);
}
